var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi2326145(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_4523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.003 7.08234L9.99879 5.04785L8.99465 7.0823C8.90926 7.25523 8.74434 7.37508 8.55352 7.40281L6.30859 7.72906L7.93316 9.31254C8.07125 9.44711 8.13426 9.64105 8.10168 9.83113L7.71824 12.067L9.72609 11.0114C9.89676 10.9217 10.1007 10.9217 10.2714 11.0114L12.2794 12.067L11.8958 9.83121C11.8631 9.64113 11.9261 9.44715 12.0643 9.31254L13.6888 7.72906L11.4441 7.40281C11.2533 7.37508 11.0884 7.25523 11.003 7.08234Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.845 0H2.15492C0.966719 0 0 0.96668 0 2.15492V15.3346C0 16.5229 0.966719 17.4896 2.15492 17.4896H7.24688L9.58562 19.8284C9.69551 19.9382 9.84453 20 9.99992 20C10.1553 20 10.3044 19.9383 10.4143 19.8284L12.753 17.4896H17.845C19.0333 17.4896 20 16.5229 20 15.3346V2.15492C20 0.96668 19.0333 0 17.845 0ZM15.3582 7.73945L13.1041 9.93656L13.6311 13.0071C13.6407 13.0491 13.6457 13.093 13.6457 13.138C13.6457 13.4611 13.3842 13.7231 13.0613 13.7239C13.0605 13.7239 13.0597 13.7239 13.0589 13.7239C12.9657 13.7239 12.8721 13.7017 12.7863 13.6566L10 12.1919L7.21395 13.6566C7.01656 13.7604 6.7773 13.7431 6.59688 13.612C6.41645 13.4809 6.32609 13.2587 6.36379 13.0389L6.89578 9.93656L4.64168 7.73941C4.48191 7.58375 4.42445 7.3509 4.49336 7.13879C4.5623 6.92664 4.74566 6.77203 4.96637 6.74L8.08129 6.2873L9.47453 3.46457C9.5732 3.26457 9.77691 3.13797 9.99992 3.13797C10.2229 3.13797 10.4266 3.26457 10.5254 3.46453L11.9187 6.2873L15.0334 6.74C15.2541 6.77207 15.4375 6.92664 15.5064 7.13879C15.5754 7.35094 15.518 7.58379 15.3582 7.73945Z",
    fill: "#5D616C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_4523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi2326145);
export default __webpack_public_path__ + "static/media/fi_2326145.d472be797494fa560623e9e68b494a08.svg";
export { ForwardRef as ReactComponent };